export default __webpack_public_path__ + "static/media/move-arte-8.a284fb4d.webp";